'use client';

import { getImageProps } from 'next/image';
import React from 'react';

import { getImageLink } from '@/services/link.service';
import { Award, AwardWrapper } from '@/types/home/home.types';
import { directusImageLoader } from '@/utils/loaders';

type Props = {
  awardWrapper: AwardWrapper;
  styles: any;
};

const AwardImage = ({ awardWrapper, styles }: Props) => {
  const imageKeys = { desktopKey: 'image-100-100', mobileKey: 'image-100-100' };

  const getImageSrc = (award: Award): string => {
    if (typeof award.image === 'string') {
      return award.image;
    }
    return award.image?.id;
  };

  const award = awardWrapper.awards_id;
  const imageSrc = getImageSrc(award);

  const common = {
    alt: 'Hero',
    width: 100,
    height: 100,
    loader: directusImageLoader,
  };

  const {
    props: { srcSet: mobile },
  } = getImageProps({
    ...common,
    src: `${getImageLink(imageSrc)}?key=${imageKeys.mobileKey}`,
  });

  const {
    props: { srcSet: desktop, ...rest },
  } = getImageProps({
    ...common,
    src: `${getImageLink(imageSrc)}?key=${imageKeys.desktopKey}`,
  });

  return (
    <picture className={styles.awardImg}>
      <source media="(max-width: 575px)" srcSet={mobile} />
      <source media="(min-width: 576px)" srcSet={desktop} />
      <img {...rest} alt="hero-banner-image" />
    </picture>
  );
};

export default AwardImage;
